import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Trans, useTranslation } from "react-i18next";
import {
  Form,
  Space,
  Button,
  Drawer,
  Select,
} from '@lockerpm/design';

import {
} from '@ant-design/icons';

import commonComponents from '../../../../../components/common';

import accessKeyServices from '../../../../../services/access-key';
import storeActions from '../../../../../store/actions';
import global from '../../../../../config/global';

function FormData(props) {
  const { ItemInput, OnboardingTooltip } = commonComponents;
  const {
    item = null,
    visible = false,
    onClose = () => {},
    onReload = () => {},
    onReview = () => {},
  } = props
  const { t } = useTranslation()
  const selectedProject = useSelector((state) => state.project.selectedProject)
  const [form] = Form.useForm()
  const [callingAPI, setCallingAPI] = useState(false);

  useEffect(() => {
    if (item) {
      form.setFieldsValue({
        editable: item.editable,
        restrictIp: item.restrict_ip,
      })
    } else {
      form.setFieldsValue({
        editable: false,
        restrictIp: [],
      })
    }
  }, [visible, item])

  const handleCreate = async () => {
    form.validateFields().then(async (values) => {
      form.setFieldsValue(values)
      setCallingAPI(true);
      const accessKey = await global.jsCore.cryptoService.makeAccessKey(selectedProject.id)
      await accessKeyServices.create(selectedProject.id, {
        editable: values.editable,
        restrict_ip: values.restrictIp,
        key: accessKey[0].encryptedString
      }).then((response) => {
        handleClose();
        onReload();
        onReview({
          id: response.id,
          access_key: accessKey[1].keyB64
        })
        // update onboarding process
        global.store.dispatch(storeActions.updateChangeProcessKey('step_4'));
      }).catch((error) => {
        global.pushError(error)
      })
      setCallingAPI(false);
    })
  }

  const handleUpdate = async () => {
    form.validateFields().then(async (values) => {
      form.setFieldsValue(values)
      setCallingAPI(true);
      await accessKeyServices.update(selectedProject.id, item.id, {
        editable: values.editable,
        restrict_ip: values.restrictIp,
      }).then(() => {
        handleClose();
        onReload();
      }).catch((error) => {
        global.pushError(error)
      })
      setCallingAPI(false);
    })
  }

  const handleClose = () => {
    onClose()
    form.resetFields();
  }

  return (
    <div className={props.className}>
      <Drawer
        title={item ? t('button.edit_access_key') : t('button.new_access_key')}
        placement="right"
        onClose={() => handleClose()}
        open={visible}
        footer={
          <Space className='flex items-center justify-end'>
            <Button
              disabled={callingAPI}
              onClick={handleClose}
            >
              {t('button.cancel')}
            </Button>
            {
              !item && <Button
                type="primary"
                loading={callingAPI}
                onClick={handleCreate}
              >
                {t('button.create')} 
              </Button>
            }
            {
              item && <Button
                type="primary"
                loading={callingAPI}
                onClick={handleUpdate}
              >
                {t('button.save')} 
              </Button>
            }
          </Space>
        }
      >
        <Form
          form={form}
          layout="vertical"
          labelAlign={'left'}
        >
          <Form.Item
            name={'editable'}
            className='mb-4'
            label={<div>
              <div className='flex items-center'>
                <p className='font-bold mr-2'>{t('access_key.permission')}</p>
                <OnboardingTooltip
                  width={300}
                  title={<div>
                    <p>
                      <Trans i18nKey={'onboarding.permission_read'} components={{ b: <b className='font-semibold'/> }}/>
                    </p>
                    <p>
                      <Trans i18nKey={'onboarding.permission_write'} components={{ b: <b className='font-semibold'/> }}/>
                    </p>
                  </div>}
                  placement="bottomLeft"
                />
              </div>
              <span>{t('access_key.permission_desc')}</span>
            </div>}
          >
            <Select
              placeholder={t('placeholder.select')}
              className="w-full"
              disabled={callingAPI}
            >
              {global.constants.ACCESS_KEY_PERMISSIONS.map((p) => (
                <Select.Option
                  value={p.value}
                  key={p.value}
                >
                  {t(p.label)}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name={'restrictIp'}
            rules={[]}
            label={<div>
              <div className='flex items-center'>
                <p className='font-bold mr-2'>{t('access_key.ip_restriction')}</p>
                <OnboardingTooltip
                  title={t('onboarding.ip_restriction')}
                  placement="top"
                />
              </div>
              <span>{t('access_key.ip_restriction_desc')}</span>
            </div>}
          >
            <ItemInput
              type={'ip'}
              disabled={callingAPI}
            />
          </Form.Item>
        </Form>
      </Drawer>
    </div>
  );
}

export default FormData;
